<template>
  <div>
    <div ref="printMe" class="view-print">
      <h1 style="color: #000; ">Print me!</h1>
    </div>
    <a :href="output" download="Gift">Save</a>
    <!-- OUTPUT -->
    <img :src="output" />
  </div>
</template>
<script>
import htmlToImage from "html-to-image";
export default {
  name: "gift",
  data() {
    return {
      output: null
    };
  },
  methods: {
    async print() {
      const el = this.$refs.printMe;
      this.output = await htmlToImage.toPng(el);
    }
  },
  mounted() {
    this.print();
  }
};
</script>
<style lang="scss" scoped>
.view-print {
  padding: 10px;
  background: yellow;
  margin-left: -1000px;
}
</style>
